module.exports = __webpack_public_path__ + "media/images/app/products/index/styles/necklaces/choker-204ea84231e114f704bb920217b1ae92.webp";